import { FundDiseaseType } from "@common/enums";


export const FundDiseaseTypes = [
  { name: 'All', value: FundDiseaseType.All },
  { name: 'Selected Disease(s)', value: FundDiseaseType.Selected },
];
